import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";

export async function downloadElementAsPdf(element, { filename, title }) {
  if (!element) throw new Error("Nothing to export");

  const width = Math.max(element.scrollWidth, element.clientWidth);
  const height = Math.max(element.scrollHeight, element.clientHeight);
  const canvas = await html2canvas(element, {
    backgroundColor: "#ffffff",
    scale: 2,
    useCORS: true,
    width,
    height,
    windowWidth: width,
    windowHeight: height,
    onclone: (documentClone) => {
      documentClone.querySelectorAll("[data-pdf-exclude]").forEach((node) => node.remove());
      const exportElement = documentClone.getElementById(element.id);
      if (!exportElement) return;
      exportElement.style.width = `${width}px`;
      exportElement.style.maxWidth = "none";
      exportElement.style.overflow = "visible";
      exportElement.querySelectorAll(".overflow-x-auto").forEach((node) => {
        node.style.overflow = "visible";
        node.style.width = "max-content";
        node.style.maxWidth = "none";
      });
      exportElement.querySelectorAll(".sticky").forEach((node) => {
        node.style.position = "static";
      });
    },
  });

  const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a3" });
  const margin = 8;
  const pageWidth = pdf.internal.pageSize.getWidth() - margin * 2;
  const pageHeight = pdf.internal.pageSize.getHeight() - margin * 2;
  const scale = Math.min(pageWidth / canvas.width, pageHeight / canvas.height);
  const imageWidth = canvas.width * scale;
  const imageHeight = canvas.height * scale;
  const x = (pdf.internal.pageSize.getWidth() - imageWidth) / 2;
  const y = (pdf.internal.pageSize.getHeight() - imageHeight) / 2;

  pdf.setProperties({ title });
  pdf.addImage(canvas.toDataURL("image/png"), "PNG", x, y, imageWidth, imageHeight, undefined, "FAST");
  pdf.save(filename);
}